module.exports = __webpack_public_path__ + "5b38fcb82982b2f6f9a4b2abe9910686.jpeg";